import React, { useState, useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
import url from "../../../config/axios";

const TotalSaleProfit = ({ data }) => {
  const [profitData, setProfitData] = useState([]);

  // 🔥 CHANGE THIS ANYTIME
  const PROFIT_PERCENTAGE = 50;

  useEffect(() => {
    const fetchProfit = async () => {
      try {
        const response = await url.get(
          `marketingagent/getProfitByMarketerId?marketerId=${data._id}`
        );

        setProfitData(response?.data?.data || []);
      } catch (error) {
        console.error("Error fetching profit data:", error);
      }
    };

    if (data?._id) {
      fetchProfit();
    }
  }, [data?._id]);

  // ✅ Transform data
  const formattedData = profitData.reduce((acc, item) => {
    const planName = item?.planId?.planName || "Unknown";
    const price = item?.planId?.pricing?.monthly?.amount || 0;

    if (!acc[planName]) {
      acc[planName] = {
        planName,
        count: 0,
        unitPrice: price,
        total: 0,
      };
    }

    acc[planName].count += 1;
    acc[planName].total += price;

    return acc;
  }, {});

  const tableData = Object.values(formattedData);

  const totalSales = tableData.reduce((sum, item) => sum + item.total, 0);

  const totalProfit = (totalSales * PROFIT_PERCENTAGE) / 100;

  return (
    <>
      {/* ================= TOTAL SALES ================= */}
      <Row className="mt-4">
        <Col xs={12}>
          <Card className="table-card p-3 p-md-4">
            <h4 className="table-title">Total Sale</h4>

            <div className="table-responsive">
              <table className="custom-table">
                <thead>
                  <tr>
                    <th>Package</th>
                    <th>Sold out</th>
                    <th>Unit Price</th>
                    <th>Total Price</th>
                  </tr>
                </thead>

                <tbody>
                  {tableData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.planName}</td>
                      <td>{item.count}</td>
                      <td>{item.unitPrice}</td>
                      <td>{item.total}</td>
                    </tr>
                  ))}

                  <tr>
                    <td style={{ fontWeight: "600" }}>Total Sale</td>
                    <td>
                      {tableData.reduce((sum, i) => sum + i.count, 0)}
                    </td>
                    <td>-</td>
                    <td style={{ fontWeight: "600" }}>
                      PKR: {totalSales}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Card>
        </Col>
      </Row>

      {/* ================= PROFIT ================= */}
      <Row className="mt-4">
        <Col xs={12}>
          <Card className="table-card p-3 p-md-4">
            <h4 className="table-title">
              Your Business Profit ({PROFIT_PERCENTAGE}%)
            </h4>

            <div className="table-responsive">
              <table className="custom-table">
                <thead>
                  <tr>
                    <th>Package</th>
                    <th>Referral</th>
                    <th>Unit Profit</th>
                    <th>Total Profit</th>
                  </tr>
                </thead>

                <tbody>
                  {tableData.map((item, index) => {
                    const unitProfit =
                      (item.unitPrice * PROFIT_PERCENTAGE) / 100;

                    const totalProfitPerPlan =
                      (item.total * PROFIT_PERCENTAGE) / 100;

                    return (
                      <tr key={index}>
                        <td>{item.planName}</td>
                        <td>{item.count}</td>
                        <td>{unitProfit}</td>
                        <td>{totalProfitPerPlan}</td>
                      </tr>
                    );
                  })}

                  <tr>
                    <td style={{ fontWeight: "600" }}>Total Profit</td>
                    <td>
                      {tableData.reduce((sum, i) => sum + i.count, 0)}
                    </td>
                    <td>-</td>
                    <td style={{ fontWeight: "600" }}>
                      PKR: {totalProfit}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default TotalSaleProfit;